import { useState, useEffect } from 'react';
import React from 'react';
import { FormControl, Typography, TextField, InputLabel, MenuItem, Container, Select, Paper, Grid, Box, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const FeeDuesDetails = () => {
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const rowsPerPageOptions = [5, 10, 25, 50];
  const [isLoading, setIsLoading] = useState(false); // For showing loader
  const [noData, setNoData] = useState(false);       // For "No Record Found"
  const [teacher, setTeacher] = useState('0');
  const [classRoom, setClassRoom] = useState('0');
  const [month, setMonth] = useState('0');
  const [section, setSection] = useState('0');
  const [classes, setClasses] = useState([]);
  const [sections, setSections] = useState([]);
  const [months, setMonths] = useState([]);
  const [ddlSession, setDdlSession] = useState([]);
  const [selectedSession, setSelectedSession] = useState('');
  const [rows, setRows] = useState([]);

  const [selectedRows, setSelectedRows] = useState([]); // State to store selected rows

  // Function to handle select all checkbox
  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const allRowIds = rows.map((row, index) => index); // Assuming index as unique identifier
      setSelectedRows(allRowIds);
    } else {
      setSelectedRows([]);
    }
  };

  // Function to handle individual row selection
  const handleRowSelect = (event, index) => {
    if (event.target.checked) {
      setSelectedRows((prev) => [...prev, index]);
    } else {
      setSelectedRows((prev) => prev.filter((id) => id !== index));
    }
  };

  const isRowSelected = (index) => selectedRows.includes(index);

  // Function to call the API for selected rows
  const callApiForSelectedRows = async () => {
    try {
      const apiUrl = 'https://wsmsv1.aidigitalsec.com/api/FeeDeposit/SendDuesWtpMsg';
      const token = sessionStorage.getItem('token');

      // Prepare the data for the API with validations
      const requestData = selectedRows.map((index) => {
        const row = rows[index];

        // Validate mobile number (10 digits)
        const isValidMobile = /^\d{10}$/.test(row.mobileNo);
        const mobileNo = isValidMobile ? row.mobileNo : '';

        // Validate email format
        const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(row.emailId);
        const emailId = isValidEmail ? row.emailId : '';

        return {
          isChecked: true,
          admissionNo: row.admissionNo,
          studentName: row.studentName,
          fathersName: row.fathersName || '',
          mobileNo: mobileNo, // Use validated mobile number
          emailId: emailId, // Use validated email
          month: row.month,
          totalFee: row.totalFee,
          paidAmount: row.paidAmount,
          outstandingBalance: row.outstandingBalance,
        };
      });

      console.log(JSON.stringify(requestData, null, 2));

      // Make the API call
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify(requestData),
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error(`Error processing rows: ${response.status}`, errorText);
        throw new Error(`Error processing rows: ${response.status}`);
      }

      // alert('API called successfully for all selected rows!');
      setSnackbarMessage('API called successfully for all selected rows!');  
  setOpenSnackbar(true);  
  setSnackbarSeverity("success");
      setSelectedRows([]); // Clear selected rows after API call
    } catch (error) {
      console.error('Error calling API:', error);
    }
  };

  useEffect(() => {
    fetchClasses();
    fetchMonths();
    fetchFinancialYears();
  }, []);

  useEffect(() => {
    fetchTableData(); // Fetch table data whenever any dropdown value changes
  }, [classRoom, section, month, selectedSession]);

  useEffect(() => {
    if (month !== '0' || classRoom !== '0' || section !== '0' || selectedSession !== '') {
      setRows([]);
    }
  }, [month, classRoom, section, selectedSession]);


  const fetchFinancialYears = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem('token');
      const response = await fetch(`${apiUrl}/ClassPromotion/GetFinancialYear`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({}),
      });
      if (!response.ok) {
        throw new Error(`Error fetching financial years: ${response.status}`);
      }
      const data = await response.json();
      if (data.data === null && data.msg === "Record Not Found") {
        throw new Error("Record Not Found");
      }
      setDdlSession(data);

      // Auto-select the current year and next year (2024-2025)
      const currentYear = new Date().getFullYear();
      const selectedYear = data.find(year => year.finanacialYear.includes(`${currentYear}-${currentYear + 1}`));
      if (selectedYear) {
        setSelectedSession(selectedYear.financialYearID);
      }

    } catch (error) {
      console.error(error);
    }
  };

  const handleResetFields = () => {
    setClassRoom('0');
    setSection('0');
    setMonth('0');
    setSections([]);
    setRows([]);
    setSelectedRows([]);
    setNoData(false);
  };


  const fetchClasses = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const response = await fetch(`${apiUrl}/Enquiry/ddlClassName`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: sessionStorage.getItem('token'),
        },
        body: JSON.stringify({}),
      });
      const data = await response.json();
      if (data.data === null && data.msg === "Record Not Found") {
        throw new Error("Record Not Found");
      }
      setClasses(data);
    } catch (error) {
      console.error('Error fetching classes:', error);
    }
  };

  const fetchSections = async (classId) => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const response = await fetch(`${apiUrl}/Teacher/ddlSection_clsId`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: sessionStorage.getItem('token'),
        },
        body: JSON.stringify({
          teacherId: sessionStorage.getItem('employeeId'),
          classId,
        }),
      });
      const data = await response.json();
      setSections(data);
    } catch (error) {
      console.error('Error fetching sections:', error);
    }
  };

  const fetchMonths = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const response = await fetch(`${apiUrl}/Fine/GetMonthList`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: sessionStorage.getItem('token'),
        },
      });
      const data = await response.json();
      setMonths(data);
    } catch (error) {
      console.error('Error fetching months:', error);
    }
  };

  const fetchTableData = async () => {
    try {
      setIsLoading(true);     // Start loading
      setNoData(false);       // Reset noData

      const apiUrl = process.env.REACT_APP_BASE_URL;
      const response = await fetch(`${apiUrl}/FeeDeposit/AllDues`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: sessionStorage.getItem('token'),
        },
        body: JSON.stringify({
          classId: classRoom,
          sectionId: section,
          monthId: month,
          sessionId: selectedSession,
        }),
      });

      if (!response.ok) {
        throw new Error(`Error fetching table data: ${response.status}`);
      }

      const data = await response.json();

      if (!data || !data.length) {
        setRows([]);
        setNoData(true);  // Show "No Record Found"
      } else {
        setRows(data);
        setNoData(false);
      }
    } catch (error) {
      console.error('Error fetching table data:', error);
      setNoData(true); // Show no data on error
    } finally {
      setIsLoading(false); // Stop loading in any case
    }
  };


  const handleClassChange = (event) => {
    const selectedClassId = event.target.value;
    setClassRoom(selectedClassId);
    setSection('0'); // Clear the section field
    fetchSections(selectedClassId); // Fetch sections based on selected class ID
  };


  const handleMonthChange = (event) => {
    setMonth(event.target.value);
  };

  const handleSectionChange = (event) => {
    setSection(event.target.value);
  };

  const handleSessionChange = (event) => {
    setSelectedSession(event.target.value);
  };


  const downloadFile = async (url, filename) => {
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: sessionStorage.getItem('token'),
        },
        body: JSON.stringify({
          classId: classRoom,
          sectionId: section,
          monthId: month,
          sessionId: selectedSession,
        }),
      });
      if (!response.ok) {
        throw new Error(`Error downloading file: ${response.status}`);
      }

      const blob = await response.blob();
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = filename;
      link.click();
      window.URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error('Error downloading file:', error);
    }
  };

  const handleExportAllDues = () => {
    downloadFile('https://wsmsv1.aidigitalsec.com/api/FeeDeposit/DownloadExcel_DuesAll', 'AllDues.xlsx');
  };

  const handleExportCurrentMonthDues = () => {
    downloadFile('https://wsmsv1.aidigitalsec.com/api/FeeDeposit/DownloadExcel_CurrentMonth', 'CurrentMonthDues.xlsx');
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1); // reset to page 1
  };


  const paginatedData = rows.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );


  return (
    <Container maxWidth={false}>
      <Box
        sx={{
          backgroundColor: '#0B1F40', // dark navy blue
          padding: '12px 24px',
          boxShadow: 3,
          borderRadius: '4px 4px 0 0',
          margin: '2px auto',
          maxWidth: "100%",
        }}
      >
        <Typography variant="h4" sx={{ color: '#fff', textAlign: 'center', fontWeight: 'bold' }}>
          Fee Dues List
        </Typography> </Box>
      <Box>
        <Paper elevation={3} sx={{ padding: 3, maxWidth: "100%", margin: 'auto', marginTop: 2 }}>
          <Box>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel id="teacher-label">Session</InputLabel>
                  <Select
                    labelId="teacher-label"
                    label="Teacher"
                    value={selectedSession}
                    onChange={handleSessionChange}
                  >
                    {ddlSession.map((year) => (
                      <MenuItem key={year.financialYearID} value={year.financialYearID}>
                        {year.finanacialYear}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel id="class-label">Class</InputLabel>
                  <Select
                    labelId="class-label"
                    value={classRoom}
                    label="Class"
                    onChange={handleClassChange}
                  >
                    <MenuItem value="0"><em>Select</em></MenuItem>
                    {classes.map((classItem) => (
                      <MenuItem key={classItem.classId} value={classItem.classId}>
                        {classItem.className}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel id="month-label">Month</InputLabel>
                  <Select
                    labelId="month-label"
                    value={month}
                    label="Month"
                    onChange={handleMonthChange}
                  >
                    <MenuItem value="0"><em>Select</em></MenuItem>
                    {months.map((monthItem) => (
                      <MenuItem key={monthItem.monthId} value={monthItem.monthId}>
                        {monthItem.month}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel id="section-label">Section</InputLabel>
                  <Select
                    labelId="section-label"
                    value={section}
                    label="Section"
                    onChange={handleSectionChange}
                  >
                    <MenuItem value="0"><em>Select</em></MenuItem>
                    {sections.map((sectionItem) => (
                      <MenuItem key={sectionItem.sectionId} value={sectionItem.sectionId}>
                        {sectionItem.sectionName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
            <Box display="flex" justifyContent="space-between" marginTop={2} gap={2} marginBottom={4}>
              <Button
                variant="contained"
                color="error"
                size="small"
                onClick={handleResetFields}
                sx={{
                  width: "80px",
                  height: "50px",
                  padding: "10px 0",
                  fontWeight: 'bold',
                  mt: 2 // same as others
                }}
              >
                RESET
              </Button>

              <Box display="flex" gap={2} flexWrap="wrap" mt={2}>
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={callApiForSelectedRows}
                  disabled={selectedRows.length === 0}
                  sx={{
                    width: "160px",
                    height: "50px",
                    padding: "10px 0",
                    fontWeight: 'bold',
                  }}
                >
                  Send Dues Message
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={handleExportAllDues}
                  sx={{
                    width: "160px",
                    height: "50px",
                    padding: "10px 0",
                    fontWeight: 'bold',
                  }}
                >
                  Export All Dues
                </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  size="small"
                  onClick={handleExportCurrentMonthDues}
                  sx={{
                    width: "160px",
                    height: "50px",
                    padding: "10px 0",
                    fontWeight: 'bold',
                  }}
                >
                  Export Current Month Dues
                </Button>
              </Box>
            </Box>

          </Box>

          <TableContainer
            component={Paper}
            style={{

              marginTop: "20px",
              width: '100%',
              margin: "auto",
              borderRadius: 2,
              border: '1px solid #ccc'
            }}
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell padding="checkbox">
                    <input
                      type="checkbox"
                      checked={selectedRows.length === rows.length && rows.length > 0}
                      onChange={handleSelectAll}
                    />
                  </TableCell>
                  <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', borderRight: '1px solid #ccc', borderBottom: '1px solid #ccc', fontSize: '1.1rem' }}>
                    Invoice No
                  </TableCell>
                  <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', borderRight: '1px solid #ccc', borderBottom: '1px solid #ccc', fontSize: '1.1rem' }}>
                    Admission No
                  </TableCell>
                  <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', borderRight: '1px solid #ccc', borderBottom: '1px solid #ccc', fontSize: '1.1rem' }}>
                    Student Name
                  </TableCell>
                  <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', borderRight: '1px solid #ccc', borderBottom: '1px solid #ccc', fontSize: '1.1rem' }}>
                    Class
                  </TableCell>
                  <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', borderRight: '1px solid #ccc', borderBottom: '1px solid #ccc', fontSize: '1.1rem' }}>
                    Roll No
                  </TableCell>
                  <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', borderRight: '1px solid #ccc', borderBottom: '1px solid #ccc', fontSize: '1.1rem' }}>
                    Mobile No
                  </TableCell>
                  <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', borderRight: '1px solid #ccc', borderBottom: '1px solid #ccc', fontSize: '1.1rem' }}>
                    Fee Entered On
                  </TableCell>
                  <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', borderRight: '1px solid #ccc', borderBottom: '1px solid #ccc', fontSize: '1.1rem' }}>
                    Month
                  </TableCell>
                  <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', borderRight: '1px solid #ccc', borderBottom: '1px solid #ccc', fontSize: '1.1rem' }}>
                    Total Fee
                  </TableCell>
                  <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', borderRight: '1px solid #ccc', borderBottom: '1px solid #ccc', fontSize: '1.1rem' }}>
                    Paid Amount
                  </TableCell>
                  <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', borderRight: '1px solid #ccc', borderBottom: '1px solid #ccc', fontSize: '1.1rem' }}>
                    Outstanding Balance
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {isLoading ? (
                  <TableRow>
                    <TableCell colSpan={12} align="center">
                      Loading...
                    </TableCell>
                  </TableRow>
                ) : noData ? (
                  <TableRow>
                    <TableCell colSpan={12} align="center">
                      No Record Found
                    </TableCell>
                  </TableRow>
                ) : (
                  paginatedData.map((row, index) => (
                    <TableRow key={index}  >
                      <TableCell padding="checkbox">
                        <input
                          type="checkbox"
                          checked={isRowSelected(index)}
                          onChange={(event) => handleRowSelect(event, index)}
                        />
                      </TableCell>
                      <TableCell sx={{ borderRight: '1px solid #ccc', fontSize: '1rem' }}>{row.invoiceNo}</TableCell>
                      <TableCell sx={{ borderRight: '1px solid #ccc', fontSize: '1rem' }}>{row.admissionNo}</TableCell>
                      <TableCell sx={{ borderRight: '1px solid #ccc', fontSize: '1rem' }}>{row.studentName}</TableCell>
                      <TableCell sx={{ borderRight: '1px solid #ccc', fontSize: '1rem' }}>{row.className}</TableCell>
                      <TableCell sx={{ borderRight: '1px solid #ccc', fontSize: '1rem' }}>{row.rollNo}</TableCell>
                      <TableCell sx={{ borderRight: '1px solid #ccc', fontSize: '1rem' }}>{row.mobileNo}</TableCell>
                      <TableCell sx={{ borderRight: '1px solid #ccc', fontSize: '1rem' }}>{row.feeGeneratedOn}</TableCell>
                      <TableCell sx={{ borderRight: '1px solid #ccc', fontSize: '1rem' }}>{row.month}</TableCell>
                      <TableCell sx={{ borderRight: '1px solid #ccc', fontSize: '1rem' }}>{row.totalFee}</TableCell>
                      <TableCell sx={{ borderRight: '1px solid #ccc', fontSize: '1rem' }}>{row.paidAmount}</TableCell>
                      <TableCell sx={{ borderRight: '1px solid #ccc', fontSize: '1rem' }}>{row.outstandingBalance}</TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>

          {rows.length > 0 && (
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 2 }}>
              <TextField
                select
                label="Rows per page"
                value={rowsPerPage}
                onChange={handleChangeRowsPerPage}
                sx={{ width: 150 }}
                SelectProps={{
                  native: true,
                }}
              >
                {rowsPerPageOptions.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </TextField>

              <Box>
                <Typography variant="body2" sx={{ display: 'inline-block', marginRight: 2 }}>
                  Page {page} of {Math.ceil(rows.length / rowsPerPage)}
                </Typography>
                <Button
                  variant="outlined"
                  onClick={() => handleChangePage(null, page - 1)}
                  disabled={page === 1}
                  sx={{ mr: 1 }}
                >
                  Prev
                </Button>
                <Button
                  variant="outlined"
                  onClick={() => handleChangePage(null, page + 1)}
                  disabled={page >= Math.ceil(rows.length / rowsPerPage)}
                >
                  Next
                </Button>
              </Box>
            </Box>
          )}


        </Paper>
      </Box>
      <Snackbar
  open={openSnackbar}
  autoHideDuration={4000}
  onClose={() => setOpenSnackbar(false)}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
  <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
    {snackbarMessage}
  </Alert>
</Snackbar>
    </Container>
  );
};

export default FeeDuesDetails;
